import { TabList, Tab } from '@simplywallst/ui-core';

import type { Multiple } from '../../KeyValuationMetrics';

interface Props {
  selectedMultiple: Multiple;
  preferredMultiple: Multiple;
  secondMultiple: Multiple;
  thirdMultiple: Multiple;
  handleSelect: (selectedMultiple: Multiple) => void;
}

export const KeyMetricsTabs = ({
  selectedMultiple,
  preferredMultiple,
  secondMultiple,
  thirdMultiple,
  handleSelect,
}: Props) => {
  return (
    <TabList templateColumns="repeat(4, auto)">
      <Tab
        data-cy-id="preferred-multiple"
        value={1}
        styleType="period"
        selected={selectedMultiple.name === preferredMultiple.name}
        onClick={() => {
          handleSelect(preferredMultiple);
        }}
      >
        {preferredMultiple.name}
      </Tab>
      <Tab
        data-cy-id="second-multiple"
        value={2}
        styleType="period"
        selected={selectedMultiple.name === secondMultiple.name}
        onClick={() => {
          handleSelect(secondMultiple);
        }}
      >
        {secondMultiple.name}
      </Tab>
      <Tab
        data-cy-id="third-multiple"
        value={3}
        styleType="period"
        selected={selectedMultiple.name === thirdMultiple.name}
        onClick={() => {
          handleSelect(thirdMultiple);
        }}
      >
        {thirdMultiple.name}
      </Tab>
      <Tab
        data-cy-id="others-multiple"
        value={4}
        styleType="period"
        selected={selectedMultiple.name === 'n/a'}
        onClick={() => {
          handleSelect({ name: 'n/a', fullName: 'n/a', value: '0x' });
        }}
      >
        Others
      </Tab>
    </TabList>
  );
};
